export default __webpack_public_path__ + "static/media/icon-logout.f1959bee.svg";